import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8d1bb5fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-5 lg:py-10 border-primary border-b-4 lg:border-t-6 lg:border-b-0 bg-white fixed lg:flex items-center justify-start w-full top-0 header z-40" }
const _hoisted_2 = { class: "lg:container px-4 mx-auto flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    y: "3",
    width: "24",
    height: "2",
    rx: "1",
    fill: "#545E61"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    y: "11",
    width: "24",
    height: "2",
    rx: "1",
    fill: "#545E61"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    y: "19",
    width: "24",
    height: "2",
    rx: "1",
    fill: "#545E61"
  })
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "143",
  height: "53",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M106.8 40.64H85.52v-9h6.25V15.4h15.03v8.9h-6.35v7.33h6.35v9.01zM113.76 15.4v8.9h6.35v7.33h-6.35v9.01h20.57v-9h-5.55V15.4h-15.02zM37.11 40.54h-9.88l-2.32-6.4H12.3l-2.43 6.4H0v-.1L13.61 3.66H23.7l13.41 36.87zM14.93 26.7h7.46l-3.73-11.52-3.73 11.52zM51.43 53c-6.15 0-13-3.35-13.71-9.64v-.1h9.68c.25.8.79 1.49 1.51 1.88.76.37 1.58.59 2.42.63 4.74 0 5.45-3.45 5.45-7.12V37.6a10.17 10.17 0 01-3.44 2.51c-1.3.58-2.71.87-4.13.85-6.85.1-11.9-5.35-11.9-12.78a14.26 14.26 0 013.43-9.53 12 12 0 014.07-3.04 11.6 11.6 0 014.9-1.05c3.13 0 5.55 1.15 7.17 3.46V15.4h8.67v22.62C65.45 48.18 60.91 53 51.43 53zm.2-30.8a4.99 4.99 0 00-3.9 1.53 5.38 5.38 0 00-1.54 4.03c0 3.35 2.22 5.55 5.44 5.55 3.23 0 5.45-2.2 5.45-5.55a5.55 5.55 0 00-1.54-4.03 5.14 5.14 0 00-3.9-1.52zM78.16 40.54h-8.68V15.4h8.68v4.08c1.61-2.93 4.23-4.4 7.86-4.4h1.72v8.7l-.1-.1a6.42 6.42 0 00-3.63-.85c-4.03 0-5.85 2.3-5.85 7.54v10.17zM102.97 6.18a6.3 6.3 0 01-1.77 4.32 5.84 5.84 0 01-4.18 1.79 5.84 5.84 0 01-4.19-1.79 6.3 6.3 0 01-1.76-4.32c.02-1.63.65-3.2 1.76-4.35A5.92 5.92 0 0197.02 0c1.57 0 3.09.66 4.2 1.81a6.32 6.32 0 011.75 4.37zM129.8 6.18c0 1.22-.36 2.42-1.01 3.43a6 6 0 01-2.67 2.28 5.75 5.75 0 01-6.49-1.34 6.4 6.4 0 01-1.29-6.74 6.13 6.13 0 012.2-2.77 5.8 5.8 0 017.5.77 6.32 6.32 0 011.75 4.37zM138.57 40.54h-.81v-2.41h-.6v-.63h2v.63h-.6v2.4zM139.78 37.5h.8l.6 1.67.61-1.67h.8l.41 3.04h-.7l-.3-1.79-.71 1.79h-.3l-.71-1.79-.2 1.79h-.8l.5-3.04z",
    fill: "#000"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M138.28 40.73h-.85v-2.46h-.57v-.69h2.09v.69h-.67v2.46zM139.51 37.58h.76l.66 1.67.57-1.67h.85l.38 3.15h-.75l-.2-1.77-.75 1.77h-.28l-.66-1.77-.29 1.77h-.75l.46-3.15z",
    fill: "#000"
  })
], -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = {
  key: 0,
  class: "mobile-menu bg-white w-full lg:static lg:flex transform transition duration-500 divide-y lg:divide-none border-primary border-b-4 lg:border-0"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  href: "#",
  class: "bg-primary p-2 rounded-full w-10 h-10 flex items-center justify-center"
}
const _hoisted_13 = {
  href: "#",
  class: "bg-primary p-2 rounded-full w-10 h-10 flex items-center justify-center pt-4 mt-2"
}

import { useAuth } from '@/composables/useAuth'
import DropdownMenu from '@/components/dropdownMenu/DropdownMenu.vue'
import { useRouter } from 'vue-router'
import { onMounted, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const showMenu = ref(false)
const { isLoggedIn, logout } = useAuth()
const router = useRouter()

const handleVehicles = () => {
    router.push({ name: 'vehicles' })
}
const handleDrivers = () => {
    router.push({ name: 'drivers' })
}
const handleUsers = () => {
    router.push({ name: 'users' })
}
const handleAdvices = () => {
    router.push({ name: 'advices' })
}
const handleLogout = async () => {
    await logout()
    router.push({ name: 'login' })
}
const handleInvoices = () => {
    router.push({ name: 'invoices' })
}
const checkWidth = () => (showMenu.value = document.documentElement.clientWidth >= 1024)

onMounted(() => {
    checkWidth()
    addEventListener('resize', checkWidth, true)
})

return (_ctx: any,_cache: any) => {
  const _component_IconCog = _resolveComponent("IconCog")!
  const _component_IconUser = _resolveComponent("IconUser")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_unref(isLoggedIn))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "mr-4 lg:hidden",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showMenu.value = !showMenu.value))
            }, _hoisted_5))
          : _createCommentVNode("", true),
        _hoisted_6
      ]),
      (_unref(isLoggedIn))
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("nav", _hoisted_8, [
              _createVNode(_Transition, {
                "enter-active-class": "transition duration-100 ease-out",
                "enter-from-class": "transform opacity-0",
                "enter-to-class": "transform opacity-100",
                "leave-active-class": "transition duration-75 ease-in",
                "leave-from-class": "transform opacity-100",
                "leave-to-class": "transform opacity-0"
              }, {
                default: _withCtx(() => [
                  (showMenu.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("a", {
                          href: "#",
                          class: "font-bold px-5 hover:text-secondary transition block py-5 w-full text-center lg:border-0 lg:w-auto",
                          onClick: _withModifiers(handleAdvices, ["prevent"])
                        }, " Zlecenia ", 8, _hoisted_10),
                        _createElementVNode("a", {
                          href: "#",
                          class: "font-bold px-5 hover:text-secondary transition block py-5 w-full text-center lg:border-0 lg:w-auto",
                          onClick: _withModifiers(handleInvoices, ["prevent"])
                        }, " Dokumenty ", 8, _hoisted_11)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(DropdownMenu, {
                class: "ml-5",
                items: [
                            {
                                label: 'Użytkownicy',
                                name: 'users',
                                handler: handleUsers,
                            },
                            {
                                label: 'Kierowcy',
                                name: 'drivers',
                                handler: handleDrivers,
                            },
                            {
                                label: 'Nr rejestracyjne',
                                name: 'vehicles',
                                handler: handleVehicles,
                            },
                        ]
              }, {
                "menu-button": _withCtx(() => [
                  _createElementVNode("a", _hoisted_12, [
                    _createVNode(_component_IconCog)
                  ])
                ]),
                _: 1
              }, 8, ["items"]),
              _createVNode(DropdownMenu, {
                class: "ml-5",
                items: [
                            {
                                label: 'Wyloguj',
                                name: 'logout',
                                handler: handleLogout,
                            },
                        ]
              }, {
                "menu-button": _withCtx(() => [
                  _createElementVNode("a", _hoisted_13, [
                    _createVNode(_component_IconUser)
                  ])
                ]),
                _: 1
              }, 8, ["items"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})